import { Shield } from "lucide-react";
import { fmtMoney } from "../lib/money";

export function MarginCell({ amount, pct, currency = "USD", dataTestId }) {
    if (amount == null) {
        return (
            <span
                className="text-zinc-400 text-xs"
                data-testid={dataTestId || "margin-hidden"}
            >
                —
            </span>
        );
    }
    const positive = amount >= 0;
    return (
        <span
            className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-medium border tabular-nums ${
                positive
                    ? "bg-amber-500/10 text-amber-500 border-amber-500/20"
                    : "bg-red-500/10 text-red-400 border-red-500/20"
            }`}
            title="Internal — hidden from advertiser"
            data-testid={dataTestId || "margin-cell"}
        >
            <Shield className="h-3 w-3" />
            {fmtMoney(amount, currency)}{" "}
            <span className="opacity-70">({pct?.toFixed?.(1)}%)</span>
        </span>
    );
}

export function InternalBadge() {
    return (
        <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] uppercase tracking-wider bg-amber-500/10 text-amber-500 border border-amber-500/20">
            <Shield className="h-2.5 w-2.5" /> Internal
        </span>
    );
}
